<template>

    <div class="activity_photo">
        <router-view class="router" :keyword="searchKeyword"></router-view>
        <div class="btn-menu" @click="showBackButton = !showBackButton">
            <a-icon type="menu-unfold" v-if="showBackButton"/>
            <a-icon type="menu-fold" v-if="!showBackButton"/>
        </div>
        <div :class="{'menus': true, 'show': !showBackButton}">
            <div class="search-box">
                <input type="text" v-model="keyword" class="keyword" placeholder="請輸入搜索關鍵字" @keyup="onKeyUp">
                <button @click="doSearch"><a-icon type="search" class="icon"/>搜索</button>
            </div>
            <div class="list">
                <div class="head"><a-icon type="bars" class="icon"/>相關內容</div>
                <ul class="datas">
                    <!-- <li class="item"><router-link to="/ActivityPhotos/details/11">asdfasdfasdfasf</router-link></li>
                    <li class="item"><router-link to="/ActivityPhotos/details/12">asdfasdfasdfasf</router-link></li>
                    <li class="item"><router-link to="/ActivityPhotos/details/13">asdfasdfasdfasf</router-link></li>
                    <li class="item"><router-link to="/ActivityPhotos/details/14">asdfasdfasdfasf</router-link></li>
                    <li class="item"><router-link to="/ActivityPhotos/details/15">asdfasdfasdfasf</router-link></li>
                    <li class="item"><router-link to="/ActivityPhotos/details/16">asdfasdfasdfasf</router-link></li>
                    <li class="item"><router-link to="/ActivityPhotos/details/17">asdfasdfasdfasf</router-link></li>
                    <li class="item"><router-link to="/ActivityPhotos/details/18">asdfasdfasdfasf</router-link></li>
                    <li class="item"><router-link to="/ActivityPhotos/details/19">asdfasdfasdfasf</router-link></li> -->
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from '../../components/Loading'
export default {
    components: {
        Loading,
    },
    data(){
        return {
            mode: 'top',
            title: '',
            keyword: '',
            searchKeyword: '',
            detail: null,
            loading: false,
            showBackButton: true,
        }
    },
    mounted: function(){
        this.keyword = this.$route.query.keyword || ''
    },
    methods: {
        onKeyUp: function(e) {
            if(e.key === 'Enter') {
                this.doSearch()
            }
        },
        doSearch: function(){
            this.showBackButton = true
            var keyword = this.keyword.trim()
            var params = keyword ? `?keyword=${keyword}` : ''
            var path = `/ActivityPhotos/list${params}`
            if(location.href.endsWith(path)) {
                this.searchKeyword = null
                setTimeout(() => {
                    this.searchKeyword = keyword
                }, 10)
            } else {
                this.$router.push(`/ActivityPhotos/list${params}`)
            }
        },
        onRefresh: function(){
            this.loading = true
            setTimeout(() => {
                this.loading = false
                this.detail = {}
            }, 1500)
        }
    },
    watch: {
        '$route.query.keyword': function(keyword) {
            this.keyword = keyword || ''
        },
    }
}
</script>

<style scoped>
    .activity_photo {
        width: 1000px;
        margin: 0px auto;
        display: flex;
    }

    .activity_photo > .router {
        flex: 1;
        margin-right: 20px;
    }

    .activity_photo > .menus {
        width: 260px;
        display: flex;
        flex-direction: column;
    }

    .activity_photo > .menus > .search-box {
        width: 100%;
        height: 120px;
        box-sizing: border-box;
        background-color: #FAF7EF;
        border: 1px solid #e8e8e8;
        display: flex;
        flex-direction: column;
        padding: 12px 24px;
        align-items: center;
    }

    .activity_photo > .menus > .search-box > input {
        width: 100%;
        height: 33px;
        line-height: 33px;
        padding-left: 12px;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        color: #232323;
        font-weight: 400;
        font-size: 14px;
    }

    .activity_photo > .menus > .search-box > button {
        margin-top: 20px;
        height: 33px;
        width: 80px;
        border: 1px solid #e8e8e8;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        border-radius: 4px;
        color: #232323;
        font-size: 16px;
        font-weight: 400;
        box-shadow: inset 0 1px 0 rgba(255,255,255,.15), 0 1px 1px rgba(0,0,0,.075);
    }

    .activity_photo > .menus > .search-box > button:active {
        opacity: 0.7;
    }

    .activity_photo > .menus > .search-box > button > .icon {
        margin-right: 8px;
    }

    .activity_photo > .menus > .list {
        display: flex;
        flex-direction: column;
        background-color: #fff;
        margin-top: 20px;
        box-shadow: 2px 2px 3px #e8e8e8;
    }

    .activity_photo > .menus > .list > .head {
        height: 33px;
        line-height: 33px;
        padding-left: 12px;
        font-size: 16px;
        font-weight: bold;
        color: #31708f;
        background-image: linear-gradient(to bottom,#d9edf7 0,#c4e3f3 100%);
    }

    .activity_photo > .menus > .list > .head > .icon {
        margin-right: 8px;
    }

    .activity_photo > .menus > .list > .datas {
        padding: 0 12px;
    }

    .activity_photo > .menus > .list > .datas > .item {
        height: 33px;
        line-height: 33px;
        position: relative;
        box-sizing: border-box;
        border-bottom: 1px dashed #e8e8e8;
        padding-left: 33px;
    }

    .activity_photo > .menus > .list > .datas > .item::after {
        content: '1';
        background-color: #d9534f;
        position: absolute;
        left: 7px;
        top: 7px;
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        color: #fff;
        font-size: 12px;
        border-radius: 2px;
        font-weight: 400;
    }
    
    .activity_photo > .menus > .list > .datas > .item:nth-child(2)::after {
        content: '2';
        background-color: #d9534f;
    }
    
    .activity_photo > .menus > .list > .datas > .item:nth-child(2)::after {
        content: '2';
        background-color: #d9534f;
    }
    
    .activity_photo > .menus > .list > .datas > .item:nth-child(2)::after {
        content: '2';
        background-color: #d9af4f;
    }
    
    .activity_photo > .menus > .list > .datas > .item:nth-child(3)::after {
        content: '3';
        background-color:#0365f9;
    }
    
    .activity_photo > .menus > .list > .datas > .item:nth-child(4)::after {
        content: '4';
        background-color: #1890ff;
    }
    
    .activity_photo > .menus > .list > .datas > .item:nth-child(5)::after {
        content: '5';
        background-color: #4b93ec;
    }
    
    .activity_photo > .menus > .list > .datas > .item:nth-child(6)::after {
        content: '6';
        background-color: #6203f9;
    }
    
    .activity_photo > .menus > .list > .datas > .item:nth-child(7)::after {
        content: '7';
        background-color: #8217e4;
    }
    
    .activity_photo > .menus > .list > .datas > .item:nth-child(8)::after {
        content: '8';
        background-color: #a02bb5;
    }
    
    .activity_photo > .menus > .list > .datas > .item:nth-child(9)::after {
        content: '9';
        background-color:#9174d6;
    }

    .activity_photo > .menus > .list > .datas > .item:last-child {
        border-bottom: 0;
    }

    .activity_photo > .btn-menu {
        position: fixed;
        left: 11px;
        top: 89px;
        width: 40px;
        height: 40px;
        border: 1px solid #e8e8e8;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 2px 2px 5px #eee, -2px -2px 5px #eee;
        display: none;
        align-items: center;
        justify-content: center;

    }

    .activity_photo > .btn-menu:active {
        opacity: 0.7;
    }

    @media only screen and (max-width: 1050px) {
        .activity_photo {
            width: 100%;
            margin-top: 42px;
        }

        .activity_photo > .menus {
            position: absolute;
            width: 80%;
            background-color: #fff;
            box-shadow: 2px 2px 5px #ccc;
            border-radius: 8px;
            padding: 8px;
            display: none;
        }

        .activity_photo > .menus.show {
            display: flex;
        }

        .activity_photo > .router {
            margin: 0 12px;
        }

        .activity_photo > .btn-menu {
            display: flex;
        }
    }
</style>
